<template>
  <div id="line-chart">
    <b-card class="border-radius" style="max-height:26rem">
      <a :href="'#/reimbursement?limit=25&order=createdAt&page=1&start_date=' + this.createdDateTo + '&end_date=' + this.thismonthday + '&status=Approved'">
        <div class="pb-1" id="border-reimburse">
          <h5 id="barHeading">Reimbursement</h5>
          <p id="barLabel">Approved Reimbursement</p>
        </div>
      </a>
      <div v-if="totalReimbursed === undefined">
        <p class="p-5 text-center no-data-label">
          <b-badge variant="secondary">There's no statistics data</b-badge>
        </p>
      </div>
      <div v-else>
        <canvas ref="canvas" width="550" height="300"></canvas>
      </div>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Doughnut } from 'vue-chartjs'

  export default {
    extends: Doughnut,
    data: function() {
      var currentDate = new Date();
      var monthlymonth = new Date(currentDate)
      var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
      var twoDigitFirstDate= "01";
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

      var currentDate = new Date();
      var monthly = new Date(currentDate)
      var thismonth = ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
      var twoDigitFirstDates= "31";
      var thismonthday = currentDate.getFullYear() + "-" + thismonth + "-" + twoDigitFirstDates;

      return {
        thismonthday: thismonthday,
        createdDateTo: createdDateTo,
        totalReimbursed: '',
        dataAccount: this.$store.getters['account/accountData'],
        dataChart: {
          datasets: [
            {
              data: [],
              borderWidth: 2,
              backgroundColor: ["#FF6384", "#FFCE56", "#36A2EB", "#009688", "#C5E1A5", "#7986CB", "f5cac3", "95d5b2"],
              hoverBackgroundColor: ["#FF6384", "#FFCE56", "#36A2EB", "#009688", "#C5E1A5", "#7986CB", "f5cac3", "95d5b2"]
            }
          ],
          labels: [],
          options: {
            responsive: true,
            maintainAspectRatio: false
          }
        },
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData() {
        this.$http.get(window.AppConfig.apiUrl + 'dashboard').then(response => {
          const objectKey = response.data.totalReimbursePerType;
          const objectValue = response.data.totalReimbursePerType;
          this.totalReimbursed = response.data.totalReimbursePerType;

          this.dataChart.labels = (Object.keys(objectKey));
          this.dataChart.datasets[0].data = (Object.values(objectValue));

          this.renderChart(this.dataChart, this.options)
        })
      }
    }
  }
</script>